var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompareAssetAllocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 32,
    viewBox: "0 0 64 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5356 29.7887C41.3937 29.1079 46.75 23.3216 46.75 16.2843C46.75 9.24699 41.3937 3.46071 34.5356 2.77988L34.5356 29.7887ZM31.8213 2.77991C25.4093 3.41662 20.3102 8.51611 19.6741 14.9283H31.8213V2.77991ZM19.6743 17.6426C20.3114 24.0537 25.41 29.1521 31.8213 29.7887V17.6426H19.6743Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareAssetAllocationIcon);
export default __webpack_public_path__ + "static/media/compare-asset-allocation-icon.87bf617e0dfd7bc15ca8f5b8f3fea32a.svg";
export { ForwardRef as ReactComponent };